/**
 * @generated SignedSource<<28a4adcb0f6d87dc7ec28b76bdf561da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutDutiesMessage_transaction$data = {
  readonly isCrossBorderTransaction: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTotalsDutiesMessage_transaction">;
  readonly " $fragmentType": "CheckoutDutiesMessage_transaction";
};
export type CheckoutDutiesMessage_transaction$key = {
  readonly " $data"?: CheckoutDutiesMessage_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDutiesMessage_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutDutiesMessage_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCrossBorderTransaction",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotalsDutiesMessage_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "c9ccc89f9157203ee8fc583473d8d7c0";

export default node;
